import UserRequirements from '@/components/userSurvey/requirementDescription';
import { useElementSize } from '@custom-react-hooks/use-element-size';
import { Box } from '@mui/material';

const UserRequirementsPage = () => {
  const [containerRef, containerSize] = useElementSize();

  return (
    <Box ref={containerRef} sx={{ height: '100%' }}>
      <UserRequirements maxHeight={containerSize.height} />
    </Box>
  );
};

export default UserRequirementsPage;
